import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxCsvParser } from 'ngx-csv-parser';

export class SellerModel
{
  img: string;
  aussteller: string;
  angebot: string;
  ort: string;
  stockwerk: string;
  standNr: string;
  raum: string;
  marken: string;
  text: string;
  displayImg: boolean;
  firma: string;
}

@Component({
  selector: 'app-seller-main',
  templateUrl: './seller-main.component.html',
  styleUrls: ['./seller-main.component.scss']
})
export class SellerMainComponent implements OnInit {

  sellers: SellerModel[] = [];
  standardImg = "../../../assets/imgs/placeholder_seller.png";

  constructor(private http: HttpClient,
    private ngxCsvParser: NgxCsvParser) { }

  ngOnInit() {

    this.http.get("assets/seller/seller.csv", {responseType: 'text'}).subscribe(t => {

      this.parseWithLibrary(t);
      //this.parseCsv(t);
    }, err => {
      console.log(err);
    })

  }

  parseWithLibrary(data: string)
  {
    var result = this.ngxCsvParser.csvStringToArray(data, ";");
    for(let i = 1; i < result.length -1; i++)
    {
      var model = new SellerModel();
      if(this.isEmptyOrSpaces(result[i][0]))
      {
        model.img = this.standardImg;
      }
      else
      {
        model.img = result[i][0];
      }

      model.firma = result[i][1];
      model.aussteller = result[i][2];
      model.standNr = result[i][5];
      model.marken = result[i][7];
      model.text = result[i][8];
      
      if(!this.isEmptyOrSpaces(model.text))
      {
        model.displayImg = true;
      }

      this.sellers.push(model);
    }
  }

  parseCsv(data: string)
  {
    data = data.replace(/(?:\r\n|\r|\n)/g, ";");
    var split = data.split(";");
    //var mod = 9;
    for(var i = 10; i < split.length; i++)
    {
      var model = new SellerModel();
      
      if(this.isEmptyOrSpaces(split[i]))
      {
        model.img = this.standardImg;
      }
      else
      {
        model.img = split[i];
      }


      i++;
      model.firma = split[i];
      i++;
      model.aussteller = split[i];
      i++;
      //model.angebot = split[i];
      i++;
      //model.ort = split[i];
      i++;
      //model.stockwerk = split[i];
      //i++;
      model.standNr = split[i];
      i++;
      model.raum = split[i];
      i++;
      model.marken = split[i];
      i++;
      model.text = split[i];
      //i = i+ 3;

      if(!this.isEmptyOrSpaces(model.text))
      {
        model.displayImg = true;
      }

      this.sellers.push(model);
    }
  }


  isEmptyOrSpaces(str: string){
    return typeof str === 'undefined' || str === null || str.match(/^ *$/) !== null;
  }
}
